<script lang="ts">

    import { dialogs } from "./dialog";
    import DialogComp from "./DialogComp.svelte";
    import type { CommandHandler } from "..";

    export let command: { handler: CommandHandler, openScope: string } | undefined = undefined;


    let removeScope: any;

    $: $dialogs, dialogsUpdated();
    function dialogsUpdated() {
        if (!command) return;

        if ($dialogs.length > 0) {
            removeScope = command.handler.setScope(command.openScope);
        } else {
            removeScope?.();
        }
    }
</script>

<!----------------------------------------------------------------------------->

{#each $dialogs as dialog (dialog.id)}
  <DialogComp {dialog} />
{/each}

<!----------------------------------------------------------------------------->

<style></style>
